<template>
  <b-modal
    ref="bulkResultModal"
    :title="modalTitle"
    size="lg"
    hide-footer
    @hidden="onHidden"
  >
    <!-- Tổng hợp -->
    <div class="d-flex flex-wrap mb-3">
      <b-badge variant="success" class="mr-2 mb-1 p-2">
        Thành công: {{ successCount }}
      </b-badge>
      <b-badge variant="danger" class="mr-2 mb-1 p-2">
        Thất bại: {{ failedCount }}
      </b-badge>
      <b-badge v-if="skippedCount" variant="secondary" class="mr-2 mb-1 p-2">
        Bỏ qua: {{ skippedCount }}
      </b-badge>
    </div>

    <!-- Chi tiết từng phiếu -->
    <b-table :items="rows" :fields="fields" bordered hover small responsive>
      <template #cell(code)="data">
        <strong>{{ data.item.code || ('#' + data.item.id) }}</strong>
      </template>
      <template #cell(state)="data">
        <b-badge :variant="data.item.variant">{{ data.item.stateLabel }}</b-badge>
      </template>
      <template #cell(reason)="data">
        <span :class="{ 'text-danger': data.item.type === 'failed' }">{{
          data.item.reason || '—'
        }}</span>
      </template>
    </b-table>

    <div class="d-flex justify-content-end mt-3">
      <b-button variant="primary" size="sm" @click="close">Đóng</b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'PurchaseRequestBulkResultModal',
  data() {
    return {
      actionLabel: '',
      results: [],
      skipped: [],
      fields: [
        { key: 'code', label: 'Mã phiếu', thStyle: { width: '25%' } },
        { key: 'state', label: 'Kết quả', thStyle: { width: '20%' }, class: 'text-center' },
        { key: 'reason', label: 'Chi tiết' },
      ],
    };
  },
  computed: {
    modalTitle() {
      return this.actionLabel
        ? `Kết quả ${this.actionLabel}`
        : 'Kết quả xử lý hàng loạt';
    },
    successCount() {
      return this.results.filter((r) => r.success).length;
    },
    failedCount() {
      return this.results.filter((r) => !r.success).length;
    },
    skippedCount() {
      return this.skipped.length;
    },
    rows() {
      const done = this.results.map((r) =>
        r.success
          ? {
            id: r.id,
            code: r.code,
            type: 'success',
            variant: 'success',
            stateLabel: 'Thành công',
            reason: '',
          }
          : {
            id: r.id,
            code: r.code,
            type: 'failed',
            variant: 'danger',
            stateLabel: 'Thất bại',
            reason: r.error,
          },
      );
      const skippedRows = this.skipped.map((s) => ({
        id: s.id,
        code: s.code,
        type: 'skipped',
        variant: 'secondary',
        stateLabel: 'Bỏ qua',
        reason: s.reason || 'Không hợp lệ với thao tác này',
      }));
      // Thất bại lên trước để dễ soi, rồi bỏ qua, cuối cùng thành công
      return [
        ...done.filter((r) => r.type === 'failed'),
        ...skippedRows,
        ...done.filter((r) => r.type === 'success'),
      ];
    },
  },
  methods: {
    open({ actionLabel = '', results = [], skipped = [] } = {}) {
      this.actionLabel = actionLabel;
      this.results = results;
      this.skipped = skipped;
      this.$refs.bulkResultModal.show();
    },
    close() {
      this.$refs.bulkResultModal.hide();
    },
    onHidden() {
      // Báo cha refresh danh sách sau khi đóng
      this.$emit('closed');
    },
  },
};
</script>
